import { defaultTheme } from 'react-admin'

const desktopTypography = {
  typography: {
    fontSize: 16,
    h6: {
      fontSize: 16,
      fontWeight: 700
    },
    subtitle1: {
      fontSize: 14,
      fontWeight: 700
    },
    caption: {
      fontSize: 14,
      fontWeight: 700
    },
    body1: {
      fontSize: 16,
      fontWeight: 700
    },
    button: {
      fontSize: 16,
      fontWeight: 700
    }
  }
}
export const desktopTheme = {
  ...defaultTheme,
  ...desktopTypography,
  palette: {
    primary: {
      main: '#f57800'
    },
    background: {
      paper: '#fff7e1',
      default: '#fff7e1'
    }
  }
}
export const adminTheme = {
  ...defaultTheme,
  ...desktopTypography
}
export const otherTheme = {
  ...defaultTheme,
  palette: {
    primary: {
      main: '#f57800'
    },
    background: {
      paper: '#fff7e1',
      default: '#fff7e1'
    }
  },
  typography: {
    fontSize: 16,
    h6: {
      fontSize: 18,
      fontWeight: 700
    },
    subtitle1: {
      fontSize: 20,
      fontWeight: 700
    },
    caption: {
      fontSize: 16,
      fontWeight: 700
    },
    body1: {
      fontSize: 20,
      fontWeight: 700
    },
    button: {
      fontSize: 18,
      fontWeight: 700
    }
  }
}